import { useMemo } from 'react';
import { buildOtherDrawerMetricCollapsibleGroups } from '../../../../utils/electronicsDashboardUtils';
import { MetricCollapsibleDrawerSection, type MotorDrawerSectionProps } from '../DrawerDraggableLayout';

export type OtherElectronicsTypeDrawerSectionProps = MotorDrawerSectionProps & {
  otherClassName: string;
};

const OtherElectronicsTypeDrawerSection = ({ motorPorts, projectCode, otherClassName }: OtherElectronicsTypeDrawerSectionProps) => {
  const metricGroups = useMemo(
    () => buildOtherDrawerMetricCollapsibleGroups(motorPorts, projectCode, otherClassName),
    [motorPorts, projectCode, otherClassName]
  );

  return <MetricCollapsibleDrawerSection groups={metricGroups} />;
};

export default OtherElectronicsTypeDrawerSection;
